import React from "react";
import "./App.css";
import TypeForm from "./TypeForm";
import TypeHome from "./TypeHome";
import { Routes, Route, useLocation } from "react-router-dom";
import ExamPage from "./ExamPage";
import { AnimatePresence } from "framer-motion";
import TypeAceLanding from "./TypeAceLanding";
import TestSetup from "./TestSetup";
import LoginPage from "./LoginPage";
import SignupPage from "./SignupPage";
import Dashboard from "./Dashboard";
function App() {
  const location = useLocation();
  return(
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<TypeAceLanding/>}/>
        <Route path="/login" element={<LoginPage/>}/>
        <Route path="/signup" element={<SignupPage/>}/>
        <Route path="/dashboard" element={<Dashboard/>}/>
        <Route path="/form" element={<TypeForm/>}/>
        <Route path="/test-setup/:examId" element={<TestSetup/>}/>
        {/* Practice Routes */}
        <Route path="/classic" element={<TypeHome />} />
        <Route path="/practice/:mode" element={<TypeHome />} />
        {/* Exam Routes */}
        <Route path="/exam/:examId" element={<ExamPage />} />
      </Routes>
    </AnimatePresence>
  );
}
export default App;